import apiHelper, { APIURL } from "../api-helper";

const aiSearchServices = () => {
    const { api } = apiHelper();

    const aiSearch = async (query: string): Promise<any> => {
        const url = `${APIURL}ai-search`;
        const method = "post";
        try {
            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };
            const response = await api({ method, url, body: { query }, headers, timeout: 20000 });
            if (response?.status == 200) { return { success: true, data: response?.data?.data } }
            return { success: false, message: response?.data?.data?.message || 'An error occurred', status: response?.status };
        } catch (error: any) {
            console.error("Error aiSearch :", error);
            return { success: false, message: error?.message || 'An error occurred' };
        }
    };

    const aiAnnotate = async (query: string, entityIds: string[]): Promise<any> => {
        const url = `${APIURL}ai-search/annotate`;
        const method = "post";
        try {
            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };
            // 60s: under provider rate-limit queuing a note can take 30–50s to
            // write — waiting it out beats degrading the whole search
            const response = await api({ method, url, body: { query, entityIds }, headers, timeout: 60000 });
            if (response?.status == 200) { return { success: true, data: response?.data?.data } }
            return { success: false, message: response?.data?.data?.message || 'AI notes are unavailable right now.' };
        } catch (error: any) {
            console.error("Error aiAnnotate :", error);
            return { success: false, message: 'AI notes are unavailable right now.' };
        }
    };

    return { aiSearch, aiAnnotate };
}

export default aiSearchServices;
